import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslations } from '@libs/translations';
import { useEditorIframe } from '@libs';
import { Points } from '@styles';
import { Breadcrumbs } from '@components/Breadcrumbs';
import { CategoryNavigation } from '@components/Category-Navigation';
import { Container, PageTop, Pagination } from '@components/Help-Center-Components';

import { HELP_CENTER, HELP_ARTICLES_PER_PAGE } from '@constants';
import { VideoCard } from '@components/Help-Center-Components';

export const VideoSection = ({ data }) => {
  const { locale } = useSelector((state) => state.settings);
  const translations = useTranslations();
  const isOpenInEditorIframe = useEditorIframe();
  const links =
    data.currentCategory === `all`
      ? [
          {
            href: `/${HELP_CENTER.MAIN}`,
            name: translations.t('site.help.title'),
          },
          {
            href: '',
            name: `${data.caption}`,
          },
        ]
      : [
          {
            href: `/${HELP_CENTER.MAIN}`,
            name: translations.t('site.help.title'),
          },
          {
            href: `/${HELP_CENTER.MAIN}/${data.slug}`,
            name: `${data.caption}`,
          },
          {
            href: '',
            name: data.categories?.find((item) => item.slug === data.currentCategory)?.caption,
          },
        ];

  const categories = data.categories && [
    { id: 0, caption: translations.t(`site.help.${data.slug}.all_content`), slug: 'all', isHidden: false },
    ...data.categories,
  ];
  const paginationStartUrl =
    data.currentCategory === `all`
      ? `/${HELP_CENTER.MAIN}/${data.slug}`
      : `/${HELP_CENTER.MAIN}/${data.slug}/${data.currentCategory}`;

  return (
    <Wrapper>
      <Breadcrumbs links={links} isOpenInEditorIframe={isOpenInEditorIframe} />
      <Container>
        <PageTop title={data.caption} description={data.description} />
        <CategoryNavigationWrap>
          <CategoryNavigation
            categories={categories?.filter((item) => !item.isHidden)}
            currentCategory={data.currentCategory}
            startUrl={`/${HELP_CENTER.MAIN}/${data.slug}`}
            isOpenInEditorIframe={isOpenInEditorIframe}
          />
        </CategoryNavigationWrap>
        <CardsWrap>
          {data.items?.map((item) => (
            <VideoCard locale={locale} key={item.id} {...item} sectionUrl={data.slug} />
          ))}
        </CardsWrap>
        {data.total > HELP_ARTICLES_PER_PAGE && (
          <Pagination
            currentPage={data.currentPage}
            totalPages={Math.ceil(data.total / HELP_ARTICLES_PER_PAGE)}
            locale={locale}
            startUrl={paginationStartUrl}
          />
        )}
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin: 55px 16px 0;
  max-width: 1386px;

  @media ${Points.tablet_landscape} {
    margin: 30px 28px 0;
  }

  @media ${Points.laptop_wide} {
    margin: 40px auto 0;
    width: 1280px;
  }

  @media ${Points.fullhd} {
    width: 1386px;
  }
`;
const CategoryNavigationWrap = styled.div`
  margin: 60px 0 25px;

  @media ${Points.tablet_portrait} {
    margin: 70px 0 30px;
  }

  @media ${Points.laptop_wide} {
    margin: 80px 0 40px;
  }

  @media ${Points.fullhd} {
    margin: 90px 0 50px;
  }
`;

const CardsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 340px;
  margin: 0 auto;

  @media ${Points.tablet_portrait} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 695px;
  }

  @media ${Points.tablet_landscape} {
    width: 900px;
  }

  @media ${Points.laptop_wide} {
    grid-template-columns: repeat(3, 1fr);
    width: 1276px;
  }

  @media ${Points.fullhd} {
    width: 1384px;
  }
`;
